export default __webpack_public_path__ + "static/unionpay-9b26e7eecadcaf7d308352347a75b07c.svg";